export default __webpack_public_path__ + "static/media/conexao.955897bf.png";